import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-53f66b6d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "register"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "電郵地址", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "姓名", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "生日", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手機號碼", -1));
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  },
  class: "label"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "輸入驗證碼", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "子女數目", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "子女就讀年級(可多選)", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "密码", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "確認密碼", -1));
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  },
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_field = _resolveComponent("van-field");
  const _component_phone_input = _resolveComponent("phone-input");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
  const _component_van_col = _resolveComponent("van-col");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
    ref: "form"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, {
      class: "title",
      justify: "center"
    }, {
      default: _withCtx(() => [_createTextVNode(" 註冊 ")]),
      _: 1
    }), _hoisted_2, _createVNode(_component_van_field, {
      class: "input",
      modelValue: $data.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.email = $event),
      rules: $data.rules['email'],
      type: "email",
      placeholder: "必填",
      maxlength: "50"
    }, null, 8, ["modelValue", "rules"]), _hoisted_3, _createVNode(_component_van_field, {
      modelValue: $data.name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.name = $event),
      class: "input",
      rules: $data.rules['name'],
      placeholder: "必填",
      required: "",
      maxlength: "20"
    }, null, 8, ["modelValue", "rules"]), _hoisted_4, _createVNode(_component_van_field, {
      modelValue: $data.birthdayLabel,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.birthdayLabel = $event),
      rules: $data.rules['birthdayLabel'],
      "is-link": "",
      readonly: "",
      class: "input",
      placeholder: "必填",
      onClick: _cache[3] || (_cache[3] = $event => $data.showPicker = true)
    }, null, 8, ["modelValue", "rules"]), _hoisted_5, _createVNode(_component_phone_input, {
      phone: $data.phone,
      "onUpdate:phone": _cache[4] || (_cache[4] = $event => $data.phone = $event),
      labelText: "",
      ref: "phoneInput",
      placeholder: "必填"
    }, null, 8, ["phone"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
      class: "btn-verify",
      round: "",
      size: "large",
      color: "#633b5b",
      onClick: $options.handleSendVerifyCode
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.verifyCodeText), 1)]),
      _: 1
    }, 8, ["onClick"])]), _hoisted_7, _createVNode(_component_van_field, {
      modelValue: $data.verifyCode,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.verifyCode = $event),
      rules: $data.rules['verifyCode'],
      required: "",
      type: "number",
      class: "input",
      placeholder: "必填",
      maxlength: "6"
    }, null, 8, ["modelValue", "rules"]), _hoisted_8, _createVNode(_component_van_field, {
      modelValue: $data.childCount,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.childCount = $event),
      class: "input",
      rules: $data.rules['childCount'],
      type: "number",
      placeholder: "必填",
      min: "0"
    }, null, 8, ["modelValue", "rules"]), _hoisted_9, _createVNode(_component_van_checkbox_group, {
      modelValue: $data.grade,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.grade = $event),
      direction: "horizontal",
      disabled: $data.redioDisabled,
      style: {
        "margin": "auto",
        "width": "80%",
        "font-size": "12px"
      },
      "checked-color": "#633b5b",
      "icon-size": "17"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_checkbox, {
        name: "1",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("幼稚園")]),
        _: 1
      }), _createVNode(_component_van_checkbox, {
        name: "2",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("初小（小一至小三）")]),
        _: 1
      }), _createVNode(_component_van_checkbox, {
        name: "3",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("高小（小四至小六）")]),
        _: 1
      }), _createVNode(_component_van_checkbox, {
        name: "4",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("初中（中一至中三）")]),
        _: 1
      }), _createVNode(_component_van_checkbox, {
        name: "5",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("高中（中四至中六）")]),
        _: 1
      }), _createVNode(_component_van_checkbox, {
        name: "6",
        style: {
          "width": "50%",
          "margin-right": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("大專")]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "disabled"]), _hoisted_10, _createVNode(_component_van_field, {
      modelValue: $data.password,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.password = $event),
      class: "input",
      rules: $data.rules['password'],
      placeholder: "最少8個字元,最少一個字母,最少一個數字",
      required: "",
      type: "password",
      maxlength: "20"
    }, null, 8, ["modelValue", "rules"]), _hoisted_11, _createVNode(_component_van_field, {
      modelValue: $data.confirmPassword,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.confirmPassword = $event),
      class: "input",
      rules: $data.rules['confirmPassword'],
      placeholder: "必填",
      required: "",
      type: "password",
      maxlength: "20"
    }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_row, {
      class: "label"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, null, {
        default: _withCtx(() => [_createVNode(_component_van_checkbox, {
          modelValue: $data.confirmPolicy,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.confirmPolicy = $event),
          "checked-color": "#633b5b",
          "icon-size": "17",
          name: "1"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "font-size": "12px",
          "line-height": "inherit"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 我同意"), _createVNode(_component_router_link, {
          to: "/userTermsHK",
          style: {
            "font-weight": "bold",
            "text-decoration": "underline"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("使用條款與細則")]),
          _: 1
        }), _createTextVNode("及"), _createVNode(_component_router_link, {
          to: "/privacyPolicyHK",
          style: {
            "font-weight": "bold",
            "text-decoration": "underline"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("隱私政策")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_row, {
      class: "label"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, null, {
        default: _withCtx(() => [_createVNode(_component_van_checkbox, {
          modelValue: $data.acceptNews,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.acceptNews = $event),
          "checked-color": "#633b5b",
          "icon-size": "17",
          name: "1"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "font-size": "12px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 我希望收到教圖家長會最新消息及會員優惠資訊")]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_button, {
      class: "btn-verify",
      round: "",
      size: "large",
      color: "#633b5b",
      onClick: $options.handleRegister,
      disabled: $data.submitButton,
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("註冊")]),
      _: 1
    }, 8, ["onClick", "disabled"])])]),
    _: 1
  }, 512), _createVNode(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $data.showPicker = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      title: "月份",
      columns: $data.columns,
      onCancel: _cache[12] || (_cache[12] = $event => $data.showPicker = false),
      onConfirm: $options.onConfirm
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_dialog, {
    show: $data.show,
    "onUpdate:show": _cache[14] || (_cache[14] = $event => $data.show = $event),
    title: "",
    confirmButtonText: "打開app",
    onConfirm: $options.opepApp
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, {
      justify: "center",
      style: {
        "text-align": "center",
        "padding": "20px 0"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 注册成功，快打開APP體驗一下吧 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["show", "onConfirm"])]);
}